module.exports = __webpack_public_path__ + "img/logo-apple-touch-114.d46c6bfe.png";